import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen bg-obsidian flex items-center justify-center text-subtle">…</div>;
  }
  if (user === false) return <Navigate to="/sbt-panel-7391/login" replace />;
  return children;
}
